import {
  Box,
  Button,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';

interface OnboardingPageWrapperProps {
  children: React.ReactNode;
  onButtonClick: () => void;
  buttonTitle?: string;
  isButtonDisabled?: boolean;
}

export const OnboardingPageWrapper = ({
  children,
  onButtonClick,
  buttonTitle,
  isButtonDisabled,
}: OnboardingPageWrapperProps) => {
  const isMobile = useMediaQuery(queryHelpers.down('tablet'));
  const { formatMessage } = useIntl();
  const resolvedButtonTitle =
    buttonTitle ?? formatMessage({ id: 'STR_CONTINUE' });

  return (
    <Box
      css={{
        background: isMobile
          ? '$surfaceBackgroundPrimary'
          : '$surfaceBackgroundTertiary',
        minHeight: '100vh',
        display: 'flex',
        alignItems: isMobile ? 'flex-start' : 'center',
        justifyContent: 'center',
        padding: isMobile ? '0' : '$three',
      }}
    >
      <Box
        css={{
          width: '100%',
          maxWidth: isMobile ? '100%' : '708px',
          background: isMobile
            ? '$surfaceBackgroundPrimary'
            : '$surfaceCardSecondary',
          boxShadow: isMobile ? 'none' : '$card',
          borderRadius: isMobile ? '0' : '24px',
        }}
      >
        {children}
        <Box
          css={{
            width: '100%',
            borderTop: '1px solid $onSurfaceBorderDefault',
            padding: '$one $twoAndHalf',
            ...(isMobile
              ? {
                  position: 'fixed',
                  bottom: 0,
                  left: 0,
                  background: '$surfaceBackgroundPrimary',
                }
              : { display: 'flex', justifyContent: 'flex-end' }),
          }}
        >
          <Button
            priority="primary"
            size="large"
            css={{
              width: isMobile ? '100%' : '220px',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onClick={onButtonClick}
            disabled={isButtonDisabled}
          >
            {resolvedButtonTitle}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
